import React from 'react';
import Header from './Header';
import Footer from './Footer';

const AboutUs = () => {
    return (
        <div className="app-container">
            <Header />

            <main className="main-content">
                <section className="section">
                    <h2>राष्ट्रीय युवा मोर्चा (RYM)</h2>
                    <p>
                        राष्ट्रीय युवा मोर्चा (RYM) एक प्रेरणादायक और गतिशील संगठन है, जो भारत के युवाओं को सशक्त
                        बनाने और उन्हें समाज के सकारात्मक बदलाव के लिए प्रेरित करने का कार्य करता है। हम युवाओं को उनके
                        अधिकारों और कर्तव्यों के प्रति जागरूक करते हैं और उन्हें राष्ट्र निर्माण की दिशा में सक्रिय रूप से
                        भागीदार बनने के लिए प्रेरित करते हैं।
                    </p>
                    <h3>हमारा उद्देश्य:</h3>
                    <p>
                        राष्ट्रीय युवा मोर्चा का मुख्य उद्देश्य युवाओं को आत्मनिर्भर, जिम्मेदार नागरिक बनाना है, ताकि
                        वे समाज में प्रभावी योगदान दे सकें। हम युवाओं को राजनीति, समाज सेवा, शिक्षा, स्वास्थ्य, और पर्यावरण
                        जैसे महत्वपूर्ण मुद्दों पर जागरूक कर उन्हें नेतृत्व की भूमिका निभाने के लिए प्रेरित करते हैं।
                    </p>
                    <h3>हमारे प्रमुख कार्य:</h3>
                    <ul>
                        <li>युवाओं को सशक्त करना: हम युवाओं के लिए नेतृत्व क्षमता विकास और कौशल प्रशिक्षण कार्यक्रमों का आयोजन करते हैं।</li>
                        <li>राजनीतिक और सामाजिक जागरूकता: हम युवाओं को लोकतांत्रिक प्रक्रिया और उनके अधिकारों के बारे में जागरूक करते हैं।</li>
                        <li>स्वास्थ्य और कल्याण: हम शारीरिक और मानसिक स्वास्थ्य को बढ़ावा देने के लिए कार्यक्रमों का आयोजन करते हैं।</li>
                        <li>शैक्षिक सशक्तिकरण: हम युवाओं को बेहतर शैक्षिक अवसर प्रदान करने के लिए प्रयासरत हैं।</li>
                        <li>महिला सशक्तिकरण: हम महिलाओं के अधिकारों और समानता के लिए विभिन्न अभियान चलाते हैं।</li>
                    </ul>
                    <h3>हमारी संरचना:</h3>
                    <p>
                        राष्ट्रीय युवा मोर्चा का संगठनात्मक ढांचा केंद्रिय, राज्य, जिला और स्थानीय स्तर पर कार्य करता है। हम
                        युवाओं को विभिन्न स्तरों पर जोड़ते हुए समाज में प्रभावी योगदान देने के लिए अवसर प्रदान करते हैं।
                    </p>
                    <h3>हमारा दृष्टिकोण:</h3>
                    <p>
                        हमारा दृष्टिकोण है कि यदि युवाओं को सही दिशा और समर्थन दिया जाए, तो वे समाज में महत्वपूर्ण बदलाव ला सकते
                        हैं और देश के भविष्य के नेता बन सकते हैं। हम सोशल मीडिया और डिजिटल प्लेटफार्मों के माध्यम से अपने
                        अभियानों को फैलाते हैं, ताकि अधिक से अधिक युवा जुड़ सकें।
                    </p>
                    <h3>हमारा मिशन:</h3>
                    <p>
                        हमारा मिशन है हर युवा को एक बेहतर नागरिक बनाने, समाज में सकारात्मक बदलाव लाने, और देश के लिए प्रेरणादायक
                        नेतृत्व तैयार करने के लिए उन्हें सशक्त बनाना।
                    </p>
                    <p>
                        हम विश्वास करते हैं कि राष्ट्रीय युवा मोर्चा के माध्यम से हम देश में एक मजबूत और समृद्ध समाज का निर्माण कर
                        सकते हैं, जहां युवा समाज के हर पहलू में सक्रिय रूप से योगदान दे सकें।
                    </p>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default AboutUs;
